import { Icon } from "@iconify/react";
import { useStateMachine } from "little-state-machine";
import { useState } from "react";
import { updateState } from "../littleStateMachine/updateRedirectUrl";

function DeveloperSettings() {
  const [isOpen, setIsOpen] = useState(false);
  const { state, actions } = useStateMachine({
    actions: { updateState },
  });

  const socialLoginEnabled = Boolean(state.developerSettings?.socialLoginEnabled);

  if (import.meta.env.VITE_PUBLIC_DEV !== "true") {
    return null;
  }

  return (
    <div className="fixed right-4 bottom-4 z-50 flex flex-col items-end gap-3">
      {isOpen && (
        <div className="w-72 rounded-xl border border-slate-200 bg-white p-4 shadow-xl">
          <h3 className="mb-3 text-sm font-semibold text-slate-900">Developer settings</h3>
          <label className="flex cursor-pointer items-center justify-between gap-4 rounded-lg border border-slate-200 p-3">
            <span className="text-sm text-slate-700">Enable social login</span>
            <input
              type="checkbox"
              className="h-4 w-4 cursor-pointer accent-emerald-600"
              checked={socialLoginEnabled}
              onChange={(event) => {
                actions.updateState({
                  developerSettings: { socialLoginEnabled: event.target.checked },
                });
              }}
            />
          </label>
        </div>
      )}

      <button
        type="button"
        className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-slate-900 text-white shadow-lg transition hover:bg-slate-800"
        aria-label="Toggle developer settings"
        onClick={() => {
          setIsOpen((open) => !open);
        }}
      >
        <Icon icon="prime:cog" className="text-xl" />
      </button>
    </div>
  );
}

export default DeveloperSettings;
